module.exports = __webpack_public_path__ + "static/media/Map_4.35bb69b0.png";